import { useState } from 'react';

export interface MitreTactic {
  name: string;
  observed: boolean;
  techniques: string[];
}

// Barra della kill chain MITRE ATT&CK: un quadratino per tattica, evidenziato quando osservata.
export default function MitreBar({ tactics }: { tactics: MitreTactic[] }) {
  const [open, setOpen] = useState(false);
  const observedCount = tactics.filter(t => t.observed).length;

  return (
    <div className="relative inline-block">
      <button onClick={() => setOpen(v => !v)}
        className="flex items-center gap-1.5 border border-gray-200 rounded-md px-2 py-1 hover:bg-gray-50">
        <span className="flex gap-0.5">
          {tactics.map(t => (
            <span key={t.name} title={t.name}
              className={`w-2.5 h-2.5 rounded-[2px] ${t.observed ? 'bg-red-500' : 'bg-gray-200'}`} />
          ))}
        </span>
        <span className="text-xs text-gray-500">{observedCount}/{tactics.length}</span>
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => setOpen(false)} />
          <div className="absolute z-20 mt-1 w-72 bg-white border border-gray-200 rounded-lg shadow-lg p-2 max-h-80 overflow-y-auto">
            {tactics.map(t => (
              <div key={t.name} className="flex items-start gap-2 px-2 py-1 text-xs">
                <span className={`mt-1 w-2.5 h-2.5 rounded-[2px] shrink-0 ${t.observed ? 'bg-red-500' : 'bg-gray-200'}`} />
                <span className={t.observed ? 'text-gray-900 font-medium' : 'text-gray-400'}>
                  {t.name}
                  {t.techniques.length > 0 && (
                    <span className="text-gray-500 font-normal"> · {t.techniques.join(', ')}</span>
                  )}
                </span>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
